<template>
  <div id="ylAboutAdvantages" :class="isMobileScreen ? '' : 'ylAboutAdvantages'">
    <ylAboutAdvantagesMobile v-if="isMobileScreen" v-bind="$attrs" :list="list" />
    <ylAboutAdvantagesPC v-else v-bind="$attrs" :list="list" />
  </div>
</template>
<script>
export default {
  name: "ylAboutAdvantages",
  components: {
    ylAboutAdvantagesMobile: () => import("./components/mobile.vue"),
    ylAboutAdvantagesPC: () => import("./components/pc.vue"),
  },
  data() {
    return {
      list: [],
    };
  },
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
  created() {
    this.coreAdvantages();
  },
  methods: {
    async coreAdvantages() {
      let res = await this.$api.coreAdvantages();
      this.list = res;
    },
  },
};
</script>
<style lang="scss" scoped>
.ylAboutAdvantages {
  background-color: #f3f4f4;
}
</style>